import styled from 'styled-components';

import {
  Z_INDEX_TOP,
  NAV_HEIGHT,
  DESKTOP_MIN_BREAK,
  DEFAULT_FONT_FAMILY,
} from '#/shared/constants';
import MenuCloseIconBase from '#/shared/components/GeneratedIcons/generic/Close';
import { ClearButton } from '#/shared/components/Styled';
import { NavToggleButtonText } from '#/shared/components/NavBar/styled';

export const DialogBackground = styled.div`
  position: fixed;
  background-color: ${props => props.theme.dialogBg};
  z-index: ${Z_INDEX_TOP};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const DialogDiv = styled.div`
  z-index: ${Z_INDEX_TOP};
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  font-family: ${DEFAULT_FONT_FAMILY};
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 100vh;
`;

export const TopBar = styled.div`
  position: absolute;
  width: 100%;
  /* must provide z-index value so checkmarks aren't on top of bar */
  z-index: 1;
  background: ${props => props.theme.navHeaderBg};
  color: ${props => props.theme.dialogNavText};
  height: ${NAV_HEIGHT};
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${NAV_HEIGHT};
  min-height: calc(100vh - ${NAV_HEIGHT});
`;

export const TitleContainer = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  pointer-events: none;
`;

export const Title = styled.h2`
  color: ${props => props.theme.dialogNavText};
  font-size: 1.2em;
  font-weight: normal;
  display: inline;
  padding: 5px;
`;

export const CloseIcon = styled(MenuCloseIconBase).attrs(props => ({
  fill: props.theme.dialogNavText,
  width: 24,
  height: 24,
}))``;

export const CloseButton = styled(ClearButton)`
  flex: 0 0 auto;
  display: flex;
  font-size: 1rem;
  align-items: center;
  margin: 0 10px 0 0;
  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    justify-content: flex-end;
    margin: 0 20px 0 0;
  }
  @media (any-hover: hover) {
    &:hover {
      background-color: transparent;
    }
  }
`;

export const CloseButtonText = styled(NavToggleButtonText)`
  color: ${props => props.theme.dialogNavText};
  margin: 0 5px 2px 5px;
`;
